export const removeSpecialCharacters = (value) => {
  if(!value) {
    return null
  }

  return value.replace(/\D/g, "")
}